
export const am_admin = 'am-org-admin'
export const am_dashboard = "am-poc-dashboard"
export const am_organization = "am-organization"
export const am_token = "am-token"
export const am_report = "am-report"
export const am_vertical = "am-vertical"
export const invitation = "am-invitation"
export const assessment_report = "am-assessment-report"
export const team_assessment_report = "am-team-assessment-report"
export const overview = "am-overview"
export const am_org_tickets="am-org-tickets"
export const am_permissions = "am-permissions"

export const am_dashboard_routes ={
    dashboard_home: `/${am_admin}/${am_dashboard}`,
    am_organization: `/${am_admin}/${am_organization}`,
    am_token: `/${am_admin}/${am_token}`,
    am_report: `/${am_admin}/${am_report}`,
    am_vertical_detail: `/${am_admin}/${am_dashboard}/${am_vertical}/:id/:survey_id`,
    create_invitation:`/${am_admin}/${am_organization}/${invitation}`,
    assessment_report:`/${am_admin}/${am_organization}/${assessment_report}/:user_id/:responseid`,
    team_assessment_report:`/${am_admin}/${am_organization}/${team_assessment_report}/:user_id/:survey_id`,
    module_usage: `/${am_admin}/${am_dashboard}/${overview}/:tab`,
    am_user_report: `/${am_admin}/${am_report}/user-report/:survey_id/:response_id`,
    am_org_tickets: `/${am_admin}/${am_org_tickets}`,
    am_permissions: `/${am_admin}/${am_permissions}`,

}

export default am_dashboard_routes
